import { Paper } from "@mui/material";
import React, { useContext, useState } from "react";

import { WizardContext } from "../../context/Wizard";
import { getFinancialDataTimeSeries } from "../../utils/Modernization";
import { RetrofitsFinancialChartDiagramWrapper } from "./RetrofitsFinancialChartDiagramWrapper";
import { RetrofitsFinancialChartTabsWrapper } from "./RetrofitsFinancialChartTabsWrapper";

export const RetrofitsFinancialTimeSeriesChartWithEchart = ({
  chartHeight = 350,
  className,
  selectedMeauresRiched,
  title,
  unit,
}) => {
  const { yearRange } = useContext(WizardContext);
  const [activeTabName, setActiveTabName] = useState("totals");
  const [isYearly, setIsYearly] = useState(false);
  const [isPartitions, setIsPartitions] = useState(false);

  const { dataForChart } = getFinancialDataTimeSeries({
    maxYear: yearRange[1],
    minYear: yearRange[0],
    selectedMeaures: selectedMeauresRiched,
  });

  return (
    <Paper className={`relative  ${className}`}>
      <section className="flex items-start justify-between gap-6">
        <div className="w-full">
          {title && <h2 className="font-ds-headline-lg mb-2 text-center">{title}</h2>}
          <RetrofitsFinancialChartTabsWrapper
            isPartitions={isPartitions}
            isYearly={isYearly}
            setActiveTabName={setActiveTabName}
            setIsPartitions={setIsPartitions}
            setIsYearly={setIsYearly}
          />
          <RetrofitsFinancialChartDiagramWrapper
            activeTabName={activeTabName}
            chartHeight={chartHeight}
            dataForChart={dataForChart}
            isPartitions={isPartitions}
            isYearly={isYearly}
            unit={unit}
            yearRange={yearRange}
          />
        </div>
      </section>
    </Paper>
  );
};
